// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"extension"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4V5H19V11H20C21.1046 11 22 11.8954 22 13C22 14.1046 21.1046 15 20 15H19V21H14.4646C14.2219 19.3039 12.7632 18 11 18C9.23676 18 7.77806 19.3039 7.53544 21H3V16.4646C4.69615 16.2219 6 14.7632 6 13C6 11.2368 4.69615 9.77806 3 9.53544V5H9V4Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4V5H19V11H20C21.1046 11 22 11.8954 22 13C22 14.1046 21.1046 15 20 15H19V21H14.4646C14.2219 19.3039 12.7632 18 11 18C9.23676 18 7.77806 19.3039 7.53544 21H3V16.4646C4.69615 16.2219 6 14.7632 6 13C6 11.2368 4.69615 9.77806 3 9.53544V5H9V4Z","fill-rule":"evenodd","stroke-linecap":"square","stroke-width":2,"clip-rule":"evenodd"},"nodeName":"path","children":[]}]}]};

@tag('t-icon-extension')
export default class ExtensionIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'extension',
    }
  }
}
